import React from "react";
import { Container, Row, Col } from "reactstrap";
import heroImg from "../../assests/images/fintof.png";
//import "./hero-section.css";

const HeroSection = () => {
  return (
    <section>
      <Container className="main"  fluid>

       {/* <Row>
          <Col lg="6" md="6">
            <div className="hero__content">
              <h1 color= "red"  className="mb-4 hero__title">
              Esprit d'entreprise <br /> 
              </h1>
              <h6 class="big" className="mb-5">
             Rejoignez-nous pour une expérience éducative exceptionnelle au sein d'une communauté dynamique d'apprentissage.
              </h6>
            </div>
        
          </Col>

          <Col lg="6" md="6">
            <img src={heroImg} alt=""  width="900" height="600"   />
          </Col>
         </Row> */}

<img
  src={heroImg}
  alt="Hero section"
  style={{
    width: "100vw",
             // ⬅️ نقص الارتفاع هنا
    objectFit: "cover",       // يحافظ على الصورة بدون تشويه
    objectPosition: "center", // يركز القص من الوسط
    display: "block",
    marginLeft: "calc(-50vw + 50%)"
  }}
/>




    </Container>
    </section>
  );
};

export default HeroSection;
